'use client'

import Image from 'next/image'
import type { StaticImageData } from 'next/image'
import { useCallback, useEffect, useState } from 'react'

import { DEFAULT_IMG_URI } from '@src/utils/constants.util'
import { cn } from '@src/utils/tailwind'

export const HeroMedia = ({
  src,
  blurDataURL,
  className,
}: {
  src?: string | StaticImageData
  blurDataURL?: string
  className: string
}) => {
  const [extension, setExtension] = useState('')

  const getExtension = useCallback(async () => {
    const response = await fetch(src as string, { method: 'HEAD' })
    setExtension(response.headers.get('content-type') as any)
  }, [src])

  useEffect(() => {
    if (!src) return
    void getExtension()
  }, [src, getExtension])

  if (!src) return null

  if (extension.includes('video') && typeof src === 'string') {
    return (
      <video
        className={cn(className, 'h-full', 'w-full')}
        controls={false}
        loop
        src={src}
        autoPlay
        playsInline
        muted
      >
        <track kind="captions" />
      </video>
    )
  }

  return (
    <Image
      className={className}
      alt="Hero Banner"
      src={src}
      loading="eager"
      placeholder="blur"
      blurDataURL={blurDataURL || DEFAULT_IMG_URI} // eslint-disable-line @typescript-eslint/prefer-nullish-coalescing
      fill
    />
  )
}
